import { Box } from "@mui/system";
import { useTranslation } from "react-i18next";
import { GeneralInformationAnswer, GeneralInformationModel } from "../../../models/workflow.model";
import { OptionsQuestion, TextQuestion } from "./Questions";
import styles from "./LegalQuestions.module.scss";
import { FormikProps } from "formik";

interface Props {
  answers: GeneralInformationAnswer[];
  propertyName: string;
  isReadOnly: boolean;
  formik?: FormikProps<GeneralInformationModel> | undefined;
}

const LegalQuestionSection: React.FC<Props> = ({ answers, propertyName, isReadOnly, formik }) => {
  const { t } = useTranslation();

  const buildQuestionComponent = (answer: GeneralInformationAnswer, index: number) => {
    switch (answer.legalQuestion.type) {
      case "TEXT":
        return (
          <TextQuestion
            key={`legal_question_${answer.legalQuestion.id}`}
            propertyName={propertyName}
            index={index}
            answer={answer}
            isReadOnly={isReadOnly}
            formik={formik}
          />
        );
      case "RADIOGROUP":
        return (
          <OptionsQuestion
            key={`legal_question_${answer.legalQuestion.id}`}
            propertyName={propertyName}
            index={index}
            answer={answer}
            isReadOnly={isReadOnly}
            formik={formik}
          />
        );
      default:
        <></>;
    }
  };

  return (
    <Box className={styles.legalQuestionsSection}>
      <div className={styles.title}>
        <h3>{t("legalSectionTitle")}</h3>
      </div>

      <div className={styles.questionsContainer}>{answers.map((x, index) => buildQuestionComponent(x, index))}</div>
    </Box>
  );
};

export default LegalQuestionSection;
